import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import {
  Headline,
  List,
  Modal,
  SectionContent,
  SwitchContent,
  Text,
  WidgetCard,
  WidgetCardsContainer,
} from "../../../../components";
import {
  NavigationLinkItemStyled,
  NavigationCardItemStyled,
  BodyLabelLink,
  CardIcon,
} from "./Produtos.Style";
import { applyKey } from "../../../../utils";
import { links } from "../../../../config";

const CardCapVencedor = (props) => {
  const { label, showDetails } = props;

  const clickHandle = useCallback(
    (evt) => {
      evt.preventDefault();
      showDetails(true);
    },
    [showDetails]
  );

  return (
    <WidgetCard
      {...props}
      header={<Text textType="headline" styleAs="8" text="Cap Ganhador" />}
    >
      <NavigationLinkItemStyled href="/">
        <NavigationCardItemStyled onClick={clickHandle}>
          <BodyLabelLink
            textType="button"
            reset={{ marginBottom: "0px" }}
            text={label}
          />
          <CardIcon />
        </NavigationCardItemStyled>
      </NavigationLinkItemStyled>
    </WidgetCard>
  );
};

CardCapVencedor.propTypes = {
  label: PropTypes.string.isRequired,
  showDetails: PropTypes.func.isRequired,
};

const DetailItem = ({ title, detail }) => (
  <div>
    <Text as="h5" text={title} bodyStrong textSize="sm" />
    {detail}
    <hr />
  </div>
);

DetailItem.propTypes = {
  title: PropTypes.string.isRequired,
  detail: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

const conteudoCapGanhadorUnico = (
  <>
    <Text as="h5" text="Valor do título" bodyStrong textSize="sm" />
    <Text textSize="sm">
      Você guarda de uma única vez entre R$ 400 e R$ 5 mil e concorre a mais de
      5 mil prêmios de até R$ 5 milhões.Você guarda de uma única vez entre R$
      400 e R$ 5 mil e concorre a mais de 5 mil prêmios de até R$ 5 milhões.
    </Text>
    <hr />
    <Text as="h5" text="Indenização" bodyStrong textSize="sm" />
    <Text textSize="sm" text="Não tem" />
    <hr />
    <Text
      as="h5"
      text="Duração do título (vigência)"
      bodyStrong
      textSize="sm"
    />
    <Text textSize="sm" text="48 meses" />
    <hr />
    <Text as="h5" text="Sorteios" bodyStrong textSize="sm" />
    <Text
      textSize="sm"
      text="Os sorteios são realizados no último sábado do mês, pela Loteria Federal."
    />
    <hr />
    <Text as="h5" text="Prêmios mensais" bodyStrong textSize="sm" />
    <List
      styleType="disc"
      listItems={[
        "120 prêmios do valor do seu pagamento;",
        "2 prêmios de 5 vezes o valor do seu pagamento;",
        "1 prêmio de 1.000 vezes o valor do seu pagamento.",
      ]}
      forEach={(premio) => <Text textSize="sm" text={premio} />}
    />
  </>
);

const conteudoCapGanhadorMensal = (
  <>
    <Text as="h5" text="Valor do título" bodyStrong textSize="sm" />
    <Text textSize="sm">
      Você guarda entre R$40 e R$500 por mês e concorre a mais de 67 mil prêmios
      de até R$ 5 milhões.
    </Text>
    <hr />
    <Text as="h5" text="Indenização" bodyStrong textSize="sm" />
    <Text textSize="sm">
      Sua família pode receber uma indenização de até R$ 20 mil em caso de morte
      acidental. Válido apenas para clientes pessoa física. Confira mais
      detalhes nas condições gerais do produto.
    </Text>
    <hr />
    <Text
      as="h5"
      text="Duração do título (vigência)"
      bodyStrong
      textSize="sm"
    />
    <Text textSize="sm" text="72 meses" />
    <hr />
    <Text as="h5" text="Sorteios" bodyStrong textSize="sm" />
    <Text textSize="sm">
      Os sorteios são realizados nos quatro últimos sábados do mês, pela Loteria
      Federal. Caso o mês tenha 5 semanas, não haverá sorteio na primeira.
    </Text>
    <hr />
    <Text as="h5" text="Prêmios semanais" bodyStrong textSize="sm" />
    <List
      styleType="disc"
      listItems={["1 prêmio de 10.000 vezes o valor da sua mensalidade."]}
      forEach={(premio) => <Text textSize="sm" text={premio} />}
    />
    <hr />
    <Text as="h5" text="Prêmios mensais" bodyStrong textSize="sm" />
    <List
      styleType="disc"
      listItems={[
        "300 prêmios de 10 vezes o valor da sua mensalidade;",
        "10 prêmios de 100 vezes o valor da sua mensalidade;",
        "1 prêmio de 1.000 vezes o valor da sua mensalidade.",
      ]}
      forEach={(premio) => <Text textSize="sm" text={premio} />}
    />
  </>
);

const Produtos = () => {
  const [showCapGanhadorDetails, setShowCapGanhadorDetails] = useState(false);
  const [contentActive, setContentActive] = useState("left");

  return (
    <SectionContent>
      <Headline nivel="2" styleAs="5" text="Produtos" />
      <Text ajustBottom="16px">
        Confira as informações do seu título, sorteios, prêmios, duração e
        outros detalhes.
      </Text>

      <WidgetCardsContainer>
        <CardCapVencedor
          label="Conferir agora"
          showDetails={setShowCapGanhadorDetails}
        />
        {applyKey(
          [
            { title: "SuperXcap", path: links.superXCap, target: "_blank" },
            { title: "Cap Aluguel", path: links.capaluguel.home },
          ],
          ({ title: cardTitle, path, target }) => (
            <WidgetCard
              header={<Text textType="headline" styleAs="8" text={cardTitle} />}
            >
              <NavigationLinkItemStyled href={path} target={target || null}>
                <NavigationCardItemStyled>
                  <BodyLabelLink
                    textType="button"
                    reset={{ marginBottom: "0px" }}
                    text="Conferir agora"
                  />
                  <CardIcon />
                </NavigationCardItemStyled>
              </NavigationLinkItemStyled>
            </WidgetCard>
          )
        )}
      </WidgetCardsContainer>
      <Modal
        show={showCapGanhadorDetails}
        onToggle={setShowCapGanhadorDetails}
        headerModal={
          <Headline
            reset={{ marginBottom: "0px" }}
            text="Cap Ganhador"
            nivel="5"
          />
        }
      >
        <SwitchContent
          leftButton="Pagamento mensal"
          rightButton="Pagamento único"
          leftContent={conteudoCapGanhadorMensal}
          rightContent={conteudoCapGanhadorUnico}
          contentActive={contentActive}
          handleChange={(content) => setContentActive(content)}
        />
      </Modal>
    </SectionContent>
  );
};

Produtos.propTypes = {};

export default Produtos;
